import { render, staticRenderFns } from "./Briefs.vue?vue&type=template&id=5e567e50&"
import script from "./Briefs.vue?vue&type=script&lang=js&"
export * from "./Briefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports